module.exports = __webpack_public_path__ + "img/doc.5acc9288.svg";